/**
 * 精选车辆推荐
 */
import React from 'react';

import { Row, Col, Icon, Tooltip, DatePicker, Input, Modal, Switch,Button} from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';

//车辆详情信息和审核
import ProcurementVehicleDetail from './ProcurementVehicleDetail';
//加载中遮罩
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';

//维保报告查看
import MaintenanceReport from '../../mall/maintenance/MaintenanceReport';
//维保查询选择
import MaintenanceSelect from '../../mall/maintenance/MaintenanceSelect';
//权限码
import { global_data } from '../../ui/auth'

class ProcurementVehicleIndex extends React.Component {

    columns = [{
        title: '公司名称',
        dataIndex: 'memberName',
        width: '8%',
    }, {
        title: '创建人',
        dataIndex: 'nickname',
        width: '4%',
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '12%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '8%',
    }
        , {
        title: '提交时间',
        dataIndex: 'insertTime',
        width: '6%',
    }
        , {
        title: '中准评估人',
        dataIndex: 'assessor',
        width: '5%',
    }, {
        title: '中准评估价(万元)',
        dataIndex: 'assessValue0',
        width: '5%',
    }, {
        title: '维保报告状态',
        dataIndex: 'report.status',
        width: '5%',
        format: { 0: "生成失败", 1: "已生成", 2: "生成中" }
    }, {
        title: '状态',
        dataIndex: 'procurementStatus',
        width: '5%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="车辆详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {global_data.authCode.includes("PROCUREMENT_VEHICLE_MANAGE") ? 
                <Tooltip title="生成评估报告">
                    <Icon type="diff" theme="filled" className="table-operate-icon" onClick={this.showReportModal.bind(this, text)} />
                </Tooltip> 
                : ""}
                {record.report != null && record.report.status !== 0 ?
                    <Tooltip title="车辆维保信息详情">
                        <Icon type="file-done" className="table-operate-icon" onClick={this.maintenanceReportDetail.bind(this, record)} />
                    </Tooltip> : ""
                }
                {global_data.authCode.includes("PROCUREMENT_VEHICLE_MANAGE") ? 
                <Tooltip title="查询车辆维保信息">
                    <Icon type="file-search" className="table-operate-icon" onClick={this.findMaintenanceSuport.bind(this, record)} />
                </Tooltip> 
                : ""}
                {/* <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip> */}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        loadingVisible: false,

        createReportVisible: false,
        simpleReport: true,
        currentId: "",

        //维保报告信息
        reportVisible: false,
        reportData: {},
        maintenanceVisible: false,
        maintenanceData: {},
    };


    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    showReportModal = (id) => {
        this.setState({ createReportVisible: true, currentId: id, simpleReport: true });
    }

    hiddenReportModal = () => {
        this.setState({ createReportVisible: false });
    };

    handleSubmit = () => {
        http.post({
            url: '/procurement/web/vehicle/assessment/generate',
            data: { vehicleId: this.state.currentId, simple: this.state.simpleReport },
            success: (res) => {
                this.setState({ createReportVisible: false });
                messager.notify("生成成功！");
            },
            error: (res) => {
                this.setState({ createReportVisible: false });
                messager.notify("生成失败！");
            }
        });
    }

    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/procurement/web/vehicle/query/detail',
            data: { id: info.id },
            success: (res) => {
                this.setState({ editData: res, visible: true, loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    delete = (id) => {
        messager.confirm("是否确定要删除这条车辆信息", () => {
            http.post({
                url: '/procurement/web/vehicle/delete',
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData)
                    messager.notify("删除成功", "提示", 'success');
                },
                error: (res) => {
                    this.state.loadData(this.state.queryData)
                    messager.notify("删除失败", "提示", 'error');
                }
            });
        })
    }

    transferData = (res, field) => {
        let data = res[field];
        for (let key in data) {
            res[field + "." + key] = data[key];
        }
        delete res[field];
    }


    // 查看维保报告详细信息
    maintenanceReportDetail = (data, e) => {
        let info = data.report;
        if (info == null) return;
        this.setState({ loadingVisible: true });
        if (info.status === 2) {
            http.get({
                url: '/maintenance/findReport',
                data: { id: info.id },
                success: (res) => {
                    this.setState({ reportData: res, reportVisible: true, loadingVisible: false });
                }, error: (res) => {
                    this.setState({ loadingVisible: false });
                }
            });
        } else {
            this.setState({ reportData: info, reportVisible: true, loadingVisible: false });
        }
    }

    //查询维保支持的维保查询列表
    findMaintenanceSuport = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/maintenance/checkSupport',
            data: { vin: info.vin },
            success: (res) => {
                res.vin = info.vin;
                res.plateNo = info.plateNo;
                res.engineNo = info.engineNo;
                this.setState({ maintenanceData: res, maintenanceVisible: true, loadingVisible: false });
            }, error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }


    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.status = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (type, value) => {
        let queryData = this.state.queryData;
        if (type === "memberName") {
            queryData.memberName = value;
        }
        else if (type === "keywords") {
            queryData.keywords = value
        }
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    radioChange = (checked) => {
        this.setState({ simpleReport: checked })
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNo = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/procurement/web/vehicle/download',
            data: queryData,
            fileName: "评估表头数据呈现指标.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                messager.alert(res.message, "异常", "error");
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="公司名称"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ width: '200px' }} />
                                <Input.Search
                                    placeholder="车辆关键字或车架号"
                                    onSearch={this.inputSearch.bind(this, "keywords")}
                                    enterButton
                                    style={{ width: '200px', margin: '0 10px' }} />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <DictSelect category="VEHICLE_PROCUREMENT_STATUS" allowClear={true} onChange={this.onSelect} style={{ width: '150px', margin: '0 10px' }} />
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/procurement/web/vehicle/query/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <ProcurementVehicleDetail
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Modal
                    title="生成评估报告"
                    visible={this.state.createReportVisible}
                    okText="确定"
                    cancelText="取消"
                    onOk={this.handleSubmit}
                    onCancel={this.hiddenReportModal}
                >
                    <Row>
                        <Col span={8}>生成报告类型:</Col>
                        <Col span={16}>
                            <Switch
                                checkedChildren="简版"
                                unCheckedChildren="详版"
                                defaultChecked
                                onChange={this.radioChange}
                            />
                        </Col>
                    </Row>
                </Modal>
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中..."
                />

                <MaintenanceReport
                    visible={this.state.reportVisible}
                    onCancel={() => this.setState({ reportVisible: false })}
                    editData={this.state.reportData}
                />
                <MaintenanceSelect
                    visible={this.state.maintenanceVisible}
                    editData={this.state.maintenanceData}
                    onCancel={() => this.setState({ maintenanceVisible: false })}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />

            </div>
        )
    }
}

export default ProcurementVehicleIndex;